<template>
    <console-layout width="100%" max-width="1280">

        <console-title>
            <span>배너 목록</span>
        </console-title>

        <console-body>
            <v-layout class="align-end">
                <span class="subtitle-2">검색수 : {{ summary.totalCount.format() }}</span>
                <v-spacer />
                <span>
                </span>
            </v-layout>
    
            <v-data-table :items="banners" :headers="bannersHeaders" hide-default-footer disable-pagination class="mt-2 mb-4 elevation-1">
            </v-data-table>
    
        </console-body>

        <v-btn fab fixed bottom right color="accent" @click="create()"><v-icon>mdi-pencil</v-icon></v-btn>

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 0,

            summary: { totalCount: 0 },
            banners: [],
            bannersHeaders: [
                { text: "no", value: "no", align: "center", /* width: 10 */ },
                { text: "이름", value: "name", align: "center", /* width: 10 */ },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, banners } = await api.console.common.banners.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.banners = banners;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        create(){
            this.$router.push(`/console/common/banners/create`);
        },
        edit(banner){
            this.$router.push(`/console/common/banners/${banner._id}`);
        },
        async remove(banner){
            if(confirm("삭제하시겠습니까?")){
                await api.console.common.banners.delete(banner);
                this.init();
            }
        }
    }
}
</script>